// extracted by mini-css-extract-plugin
export default {"hint":"useMyReservationContent_hint__u8bvB","confirmButton":"useMyReservationContent_confirmButton__XLzfs"};